
(function () {
  /* =========================================================
   * YOKUU — REBUY SMART CART TRANSLATIONS
   *
   * EN: yokuu.com/...
   * NL: yokuu.com/nl/...
   * FR: yokuu.com/fr/...
   * ========================================================= */

  const path = window.location.pathname.toLowerCase();

  let locale = 'en';

  if (/^\/nl(?:\/|$)/.test(path)) {
    locale = 'nl';
  } else if (/^\/fr(?:\/|$)/.test(path)) {
    locale = 'fr';
  }

  /* English uses the original Rebuy configuration. */
  if (locale === 'en') {
    return;
  }

  /*
   * Cross-sell widget visible in your screenshot.
   * If the widget ID changes later, change this value.
   */
  const CART_CROSS_SELL_WIDGET_ID = '308218';


  /* =========================================================
   * TRANSLATIONS
   * ========================================================= */

  const translations = {
    nl: {
      cartTitle: 'Je winkelmandje',

      emptyCartTitle: 'Je winkelmandje is leeg!',
      emptyCartText: 'Voeg je favoriete producten toe aan je winkelmandje.',
      shopNow: 'Shop nu',

      recommendations: 'Dit vind je misschien ook leuk',
      add: 'Toevoegen',
      adding: 'Toevoegen...',
      added: 'Toegevoegd',
      remove: 'Verwijderen',
      removing: 'Verwijderen...',
      removed: 'Verwijderd',
      soldOut: 'Uitverkocht',

      discountCode: 'Kortingscode',
      discountGiftCardCode: 'Kortingscode / cadeaubon',
      apply: 'Toepassen',
      invalidDiscount: 'Ongeldige kortingscode',
      giftCard: 'Cadeaubon',

      subtotal: 'Subtotaal',
      item: 'artikel',
      items: 'artikelen',

      checkout: 'Afrekenen',
      viewCart: 'Winkelmand bekijken',
      continueShopping: 'Verder winkelen',

      freeShipping: 'Gratis verzending',
      freeGift: 'Gratis cadeau',
      freeShippingReached:
        '🎉 Gratis verzending ontgrendeld!',
      freeShippingRemaining: function (amount) {
        return 'Nog ${amount} tot gratis verzending!';
      }
    },

    fr: {
      cartTitle: 'Votre panier',

      emptyCartTitle: 'Votre panier est vide !',
      emptyCartText: 'Ajoutez vos produits préférés à votre panier.',
      shopNow: 'Découvrir les produits',

      recommendations: 'Vous aimerez peut-être aussi',
      add: 'Ajouter',
      adding: 'Ajout...',
      added: 'Ajouté',
      remove: 'Supprimer',
      removing: 'Suppression...',
      removed: 'Supprimé',
      soldOut: 'Épuisé',

      discountCode: 'Code de réduction',
      discountGiftCardCode: 'Code de réduction / carte-cadeau',
      apply: 'Appliquer',
      invalidDiscount: 'Code de réduction invalide',
      giftCard: 'Carte-cadeau',

      subtotal: 'Sous-total',
      item: 'article',
      items: 'articles',

      checkout: 'Passer au paiement',
      viewCart: 'Voir le panier',
      continueShopping: 'Continuer mes achats',

      freeShipping: 'Livraison gratuite',
      freeGift: 'Cadeau offert',
      freeShippingReached:
        '🎉 Livraison gratuite débloquée !',
      freeShippingRemaining: function (amount) {
        return 'Encore ${amount} avant la livraison gratuite !';
      }
    }
  };

  const t = translations[locale];


  /* =========================================================
   * HELPERS
   * ========================================================= */

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Replace exact text nodes without destroying surrounding
   * HTML such as icons, arrows, spans, etc.
   */
  function replaceTextNodes(root, replacements) {
    if (!root) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null
    );

    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(function (node) {
      const parent = node.parentElement;

      if (!parent) return;

      const tag = parent.tagName;

      if (
        tag === 'SCRIPT' ||
        tag === 'STYLE' ||
        tag === 'NOSCRIPT'
      ) {
        return;
      }

      const original = node.nodeValue;
      const normalized = normalizeText(original).toLowerCase();

      if (!normalized) return;

      const replacement = replacements[normalized];

      if (!replacement) return;

      /*
       * Keep existing leading/trailing whitespace.
       */
      const leading = original.match(/^\s*/);
      const trailing = original.match(/\s*$/);

      const newValue =
        (leading ? leading[0] : '') +
        replacement +
        (trailing ? trailing[0] : '');

      if (node.nodeValue !== newValue) {
        node.nodeValue = newValue;
      }
    });
  }


  /* =========================================================
   * CART TITLE
   * ========================================================= */

  function translateCartTitle() {
    const root =
      document.querySelector('[data-rebuy-component="title-bar"]') ||
      document.querySelector('[data-rebuy-component-id="title_bar"]');

    if (!root) return;

    replaceTextNodes(root, {
      'your cart': t.cartTitle
    });
  }


  /* =========================================================
   * EMPTY CART
   * ========================================================= */

  function translateEmptyCart() {
    const root = document.querySelector(
      '[data-rebuy-component="cart-items"]'
    );

    if (!root) return;

    replaceTextNodes(root, {
      'your cart is empty!': t.emptyCartTitle,
      'your cart is empty': t.emptyCartTitle,

      'add your favorite items to your cart.': t.emptyCartText,
      'add your favorite items to your cart': t.emptyCartText,

      'shop now': t.shopNow
    });
  }


  /* =========================================================
   * TIERED PROGRESS BAR / FREE SHIPPING
   * ========================================================= */

  function translateProgressBar() {
  const root = document.querySelector(
    '[data-rebuy-component="progress-bar"]'
  );

  if (!root) return;

  const prompt = root.querySelector(
    '.rebuy-cart__progress-bar-prompt'
  );

  if (prompt) {
    const currentText = normalizeText(prompt.textContent);

    if (currentText) {
      /*
       * Detecteer bedrag:
       * €30,05
       * € 30,05
       * 30,05 €
       * $20.00
       */
      const amountMatch = currentText.match(
        /(?:€|£|\$)\s?\d[\d.,\s]*|\d[\d.,\s]*\s?(?:€|EUR|USD|GBP)/i
      );

      /*
       * Nog niet genoeg voor gratis verzending
       */
      if (
        amountMatch &&
        (
          /away from/i.test(currentText) ||
          /free shipping/i.test(currentText) ||
          /gratis verzending/i.test(currentText) ||
          /livraison gratuite/i.test(currentText)
        )
      ) {
        const amount = normalizeText(amountMatch[0]);

        let newText;

        if (locale === 'nl') {
          newText = `Nog ${amount} tot gratis verzending!`;
        }

        if (locale === 'fr') {
          newText = `Encore ${amount} avant la livraison gratuite !`;
        }

        if (
          newText &&
          normalizeText(prompt.textContent) !== newText
        ) {
          prompt.textContent = newText;
        }

        return;
      }

      /*
       * Gratis verzending behaald
       */
      if (
        /congrats|congratulations|unlocked|achieved|free shipping|gratis verzending|livraison gratuite/i.test(
          currentText
        )
      ) {
        let newText;

        if (locale === 'nl') {
          newText = '🎉 Gratis verzending ontgrendeld!';
        }

        if (locale === 'fr') {
          newText = '🎉 Livraison gratuite débloquée !';
        }

        if (
          newText &&
          normalizeText(prompt.textContent) !== newText
        ) {
          prompt.textContent = newText;
        }

        return;
      }
    }
  }

  /*
   * Vertaal eventuele losse labels pas NADAT
   * we de dynamische progress-tekst verwerkt hebben.
   */
  replaceTextNodes(root, {
    'free shipping':
      locale === 'nl'
        ? 'Gratis verzending'
        : 'Livraison gratuite',

    'free gift':
      locale === 'nl'
        ? 'Gratis cadeau'
        : 'Cadeau offert'
  });
}


  /* =========================================================
   * CROSS-SELL / "YOU MAY ALSO LIKE"
   * ========================================================= */

  function translateCrossSell() {
    const roots = document.querySelectorAll(
      '[data-rebuy-component="cross-sell-widget"]'
    );

    roots.forEach(function (root) {
      replaceTextNodes(root, {
        'you may also like': t.recommendations,
        'recommended for you': t.recommendations,

        'add': t.add,
        'add to cart': t.add,
        'adding': t.adding,
        'adding...': t.adding,
        'added': t.added,
        'added to cart': t.added,

        'remove': t.remove,
        'removing': t.removing,
        'removing...': t.removing,
        'removed': t.removed,

        'sold out': t.soldOut
      });
    });
  }


  /* =========================================================
   * DISCOUNT / GIFT CARD INPUT
   * ========================================================= */

  function translateDiscountInput() {
    const root = document.querySelector(
      '[data-rebuy-component="discount-input"]'
    );

    if (!root) return;

    replaceTextNodes(root, {
      'discount code': t.discountCode,
      'discount code / gift card': t.discountGiftCardCode,
      'discount / gift card code': t.discountGiftCardCode,
      'discount or gift card code': t.discountGiftCardCode,

      'gift card': t.giftCard,

      'apply': t.apply,

      'invalid discount code': t.invalidDiscount,
      'discount code is invalid': t.invalidDiscount,

      'remove': t.remove
    });

    const input = root.querySelector(
      '#rebuy-cart__discount-input'
    );

    if (input) {
      const placeholder = normalizeText(input.placeholder).toLowerCase();

      if (
        placeholder === 'discount code' ||
        placeholder === 'discount code / gift card' ||
        placeholder === 'discount / gift card code' ||
        placeholder === 'discount or gift card code'
      ) {
        const newPlaceholder =
          placeholder.includes('gift')
            ? t.discountGiftCardCode
            : t.discountCode;

        if (input.placeholder !== newPlaceholder) {
          input.placeholder = newPlaceholder;
        }
      }

      const ariaLabel = normalizeText(
        input.getAttribute('aria-label')
      ).toLowerCase();

      if (
        ariaLabel === 'discount code' ||
        ariaLabel === 'discount / gift card code'
      ) {
        input.setAttribute(
          'aria-label',
          ariaLabel.includes('gift')
            ? t.discountGiftCardCode
            : t.discountCode
        );
      }
    }
  }


  /* =========================================================
   * SUBTOTAL
   * ========================================================= */

  function translateSubtotal() {
    const root = document.querySelector(
      '[data-rebuy-component="cart-subtotal"]'
    );

    if (!root) return;

    const label = root.querySelector(
      '.rebuy-cart__flyout-subtotal-label'
    );

    if (!label) {
      replaceTextNodes(root, {
        'subtotal': t.subtotal
      });

      return;
    }

    const current = normalizeText(label.textContent);

    /*
     * Example from your screenshot:
     * "Subtotal (1 item)"
     */
    const match = current.match(
      /subtotal\s*\(\s*(\d+)\s+items?\s*\)/i
    );

    if (match) {
      const count = Number(match[1]);

      const itemLabel =
        count === 1 ? t.item : t.items;

      const newText =
        t.subtotal +
        ' (' +
        count +
        ' ' +
        itemLabel +
        ')';

      if (normalizeText(label.textContent) !== newText) {
        label.textContent = newText;
      }

      return;
    }

    if (/^subtotal$/i.test(current)) {
      if (label.textContent !== t.subtotal) {
        label.textContent = t.subtotal;
      }
    }
  }


  /* =========================================================
   * CHECKOUT AREA
   * ========================================================= */

  function translateCheckoutArea() {
    const root = document.querySelector(
      '[data-rebuy-component="checkout-area"]'
    );

    if (!root) return;

    /*
     * Text-node replacement keeps arrows/icons intact.
     */
    replaceTextNodes(root, {
      'checkout': t.checkout,
      'view cart': t.viewCart,
      'continue shopping': t.continueShopping
    });
  }


  /* =========================================================
   * REBUY WIDGET SETTINGS
   *
   * We also modify the cross-sell widget's own language
   * settings, so Rebuy doesn't immediately replace our
   * translated DOM when the widget re-renders.
   * ========================================================= */

  const widgetLanguageReplacements = {
    'you may also like': t.recommendations,
    'recommended for you': t.recommendations,

    'add': t.add,
    'add to cart': t.add,
    'adding': t.adding,
    'adding...': t.adding,
    'added': t.added,
    'added to cart': t.added,

    'remove': t.remove,
    'removing': t.removing,
    'removing...': t.removing,
    'removed': t.removed,

    'sold out': t.soldOut
  };

  function translateObjectStrings(object, seen) {
    if (!object || typeof object !== 'object') {
      return;
    }

    seen = seen || new WeakSet();

    if (seen.has(object)) {
      return;
    }

    seen.add(object);

    Object.keys(object).forEach(function (key) {
      const value = object[key];

      if (typeof value === 'string') {
        const normalized = normalizeText(value).toLowerCase();

        if (widgetLanguageReplacements[normalized]) {
          object[key] =
            widgetLanguageReplacements[normalized];
        }

        return;
      }

      if (value && typeof value === 'object') {
        translateObjectStrings(value, seen);
      }
    });
  }

  function translateRebuyWidgetSettings(widget) {
    if (!widget) return;

    if (
      String(widget.id) !==
      String(CART_CROSS_SELL_WIDGET_ID)
    ) {
      return;
    }

    const language =
      widget.data &&
      widget.data.settings &&
      widget.data.settings.language;

    if (language) {
      translateObjectStrings(language);
    }
  }


  /* =========================================================
   * LOCALIZE RECOMMENDED PRODUCT TITLES
   *
   * Rebuy documents ShopifyStorefrontHelper specifically for
   * Shopify Markets translations in Rebuy widgets.
   * ========================================================= */

  let storefrontHelperPromise = null;

  function getStorefrontHelper() {
    if (window.ShopifyStorefrontHelper) {
      return Promise.resolve(
        new window.ShopifyStorefrontHelper()
      );
    }

    if (storefrontHelperPromise) {
      return storefrontHelperPromise;
    }

    storefrontHelperPromise = new Promise(function (
      resolve,
      reject
    ) {
      const existing = document.querySelector(
        'script[data-yokuu-rebuy-storefront-helper]'
      );

      if (existing) {
        existing.addEventListener('load', function () {
          if (window.ShopifyStorefrontHelper) {
            resolve(
              new window.ShopifyStorefrontHelper()
            );
          } else {
            reject(
              new Error(
                'ShopifyStorefrontHelper did not initialize.'
              )
            );
          }
        });

        return;
      }

      const script = document.createElement('script');

      script.src =
        'https://cdn.rebuyengine.com/onsite/js/storefront-helper.js';

      script.async = true;

      script.setAttribute(
        'data-yokuu-rebuy-storefront-helper',
        'true'
      );

      script.onload = function () {
        if (window.ShopifyStorefrontHelper) {
          resolve(
            new window.ShopifyStorefrontHelper()
          );
        } else {
          reject(
            new Error(
              'ShopifyStorefrontHelper did not initialize.'
            )
          );
        }
      };

      script.onerror = function () {
        reject(
          new Error(
            'Could not load ShopifyStorefrontHelper.'
          )
        );
      };

      document.head.appendChild(script);
    });

    return storefrontHelperPromise;
  }

  function localizeCrossSellProducts(widget) {
    if (!widget) return;

    if (
      String(widget.id) !==
      String(CART_CROSS_SELL_WIDGET_ID)
    ) {
      return;
    }

    const products =
      widget.data &&
      Array.isArray(widget.data.products)
        ? widget.data.products
        : [];

    if (!products.length) {
      return;
    }

    getStorefrontHelper()
      .then(function (helper) {
        products.forEach(function (product) {
          helper.updateProductJSON(product);
        });
      })
      .catch(function (error) {
        console.warn(
          '[YOKUU] Could not localize Rebuy product titles:',
          error
        );
      });
  }


  /* =========================================================
   * TRANSLATE EVERYTHING
   * ========================================================= */

  let translationFrame = null;

  function translateSmartCart() {
    translateCartTitle();
    translateEmptyCart();
    translateProgressBar();
    translateCrossSell();
    translateDiscountInput();
    translateSubtotal();
    translateCheckoutArea();
  }

  function scheduleTranslation() {
    if (translationFrame) {
      return;
    }

    translationFrame = window.requestAnimationFrame(
      function () {
        translationFrame = null;
        translateSmartCart();
      }
    );
  }


  /* =========================================================
   * REBUY EVENTS
   * ========================================================= */

  document.addEventListener(
    'rebuy.init',
    function (event) {
      const widget =
        event.detail && event.detail.widget;

      translateRebuyWidgetSettings(widget);
      scheduleTranslation();
    }
  );

  document.addEventListener(
    'rebuy.beforeReady',
    function (event) {
      const widget =
        event.detail && event.detail.widget;

      translateRebuyWidgetSettings(widget);
      scheduleTranslation();
    }
  );

  document.addEventListener(
    'rebuy.ready',
    function (event) {
      const widget =
        event.detail && event.detail.widget;

      translateRebuyWidgetSettings(widget);
      scheduleTranslation();
    }
  );

  document.addEventListener(
    'rebuy.productsChange',
    function (event) {
      const widget =
        event.detail && event.detail.widget;

      translateRebuyWidgetSettings(widget);
      localizeCrossSellProducts(widget);

      scheduleTranslation();
    }
  );

  document.addEventListener(
    'rebuy.refresh',
    function (event) {
      const widget =
        event.detail && event.detail.widget;

      translateRebuyWidgetSettings(widget);
      scheduleTranslation();
    }
  );

  document.addEventListener(
    'rebuy:smartcart.ready',
    scheduleTranslation
  );

  document.addEventListener(
    'rebuy:smartcart.show',
    scheduleTranslation
  );

  document.addEventListener(
    'rebuy:cart.change',
    scheduleTranslation
  );


  /* =========================================================
   * MUTATION OBSERVER
   *
   * Rebuy/Vue can re-render parts of the cart after quantity
   * changes. This catches those updates.
   * ========================================================= */

  const observer = new MutationObserver(function (mutations) {
    const rebuyChanged = mutations.some(function (mutation) {
      let element =
        mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

      if (
        element &&
        typeof element.closest === 'function' &&
        element.closest(
          '.rebuy-cart, [data-rebuy-component], [id^="rebuy-widget-"]'
        )
      ) {
        return true;
      }

      return Array.from(mutation.addedNodes || []).some(
        function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return false;
          }

          return (
            node.matches &&
            (
              node.matches('.rebuy-cart') ||
              node.matches('[data-rebuy-component]') ||
              node.matches('[id^="rebuy-widget-"]') ||
              node.querySelector('.rebuy-cart') ||
              node.querySelector('[data-rebuy-component]')
            )
          );
        }
      );
    });

    if (rebuyChanged) {
      scheduleTranslation();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });


  /*
   * Initial attempt in case Rebuy has already rendered.
   */
  scheduleTranslation();
})();